export default __webpack_public_path__ + "69b9dfc38e0f178deef3ab970aa352fe.png";